export default __webpack_public_path__ + "static/media/ranking-gain-exp-step2.5c056b57.png";